export default {
  "userName": "用戶名",
  "family": "家庭",
  "familyNumber": "家庭號",
  "search": "搜索",
  "add": "添加",
}